import { useMutation } from '@apollo/client'
import { SendEmailInsurance, SendEmailInsuranceVariables } from '../../types'
import { SEND_EMAIL_INSURANCE } from './operations'

export const useSendEmailInsurance = () => {
  return useMutation<SendEmailInsurance, SendEmailInsuranceVariables>(SEND_EMAIL_INSURANCE)
}
